// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"6824":"5ed177aa","9508":"9f93777d"}[chunkId] + ".chunk.css";
};